import { render, staticRenderFns } from "./MenuType.vue?vue&type=template&id=49ddfe9c"
import script from "./MenuType.vue?vue&type=script&lang=ts"
export * from "./MenuType.vue?vue&type=script&lang=ts"
import style0 from "./MenuType.vue?vue&type=style&index=0&id=49ddfe9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports